

class StockCategoryConfigViewController extends MUIViewController implements StockCategoryConfigCellDelegate
{

    static newInstance() : StockCategoryConfigViewController {
        let vc = new StockCategoryConfigViewController('stock-category-config-view');
        vc.initWithResource('layout/stockcategory/StockCategoryConfigView.html');
        return vc;
    }

    private addButton:MUIButton = null;
    private tableView:UITableView = null;

    viewDidLoad(){
        super.viewDidLoad();

        this.addButton = MUIOutlet(this, 'add-btn', 'MUIButton');
        this.addButton.setAction(this, function(){
            this.addStockCategory(null);
        });

        this.tableView = MUIOutlet(this,"table-view", "UITableView");
        this.tableView.dataSource = this;
        this.tableView.delegate = this;
    }

    viewWillAppear(animate?) {
        super.viewWillAppear(animate);
        this.updateUI();
    }

    private updateUI(){
        if (this.viewIsLoaded == false) return;

        this.fetchedResultsController = null;
        this.reloadTreeItems();
        this.tableView.reloadData();
    }

    numberOfSections(tableview){
        return 1;
    }

    numberOfRowsInSection(tableview, section){
        return this.treeItems.length;
    }

    cellAtIndexPath(tableview, indexPath:MIOIndexPath){
        let cell = tableview.dequeueReusableCellWithIdentifier('StockCategoryConfigCell') as StockCategoryConfigCell;
        let item = this.treeItems[indexPath.row];
        cell.delegate = this;
        cell.item = item;
        cell.selectionStyle = UITableViewCellSelectionStyle.None;
        return cell;
    }

    editingStyleForRowAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath) {
        return UITableViewCellEditingStyle.Delete;
    }

    commitEditingStyleForRowAtIndexPath(tableView, editingStyle:UITableViewCellEditingStyle, indexPath:MIOIndexPath) {
        let item = this.treeItems[indexPath.row];

        if (editingStyle == UITableViewCellEditingStyle.Delete) {
            this.deleteStockCategory(item);
        }
    }

    addChildDidPress(cell:StockCategoryConfigCell, category:StockCategory){
        this.addStockCategory(category);
    }

    changeParentDidPress(cell:StockCategoryConfigCell, category:StockCategory){
        this.changeParent(category);
    }

    private treeItems:StockCategory[] = [];
    private reloadTreeItems(){
        this.treeItems = this.categoriesTree(null);
    }

    // Every category in tree order, each one right below its parent, skipping the excluded
    // category with all its subcategories. A category whose parent is not in the fetch
    // (deleted) is shown as a root so it can still be reached and moved.
    private categoriesTree(excluded:StockCategory):StockCategory[] {
        let objects = this.fetchedResultsController.fetchedObjects;

        let fetchedIDs = {};
        for (let index = 0; index < objects.length; index++){
            fetchedIDs[objects[index].identifier] = true;
        }

        let roots = [];
        let childrenByParent = {};
        for (let index = 0; index < objects.length; index++){
            let category = objects[index] as StockCategory;
            let parent = category.superCategory;
            if (parent == null || fetchedIDs[parent.identifier] == null) {
                roots.push(category);
            }
            else {
                if (childrenByParent[parent.identifier] == null) childrenByParent[parent.identifier] = [];
                childrenByParent[parent.identifier].push(category);
            }
        }

        let items:StockCategory[] = [];
        let appendBranch = function(category:StockCategory){
            if (excluded != null && category.identifier == excluded.identifier) return;
            items.push(category);
            let children = childrenByParent[category.identifier];
            if (children == null) return;
            for (let index = 0; index < children.length; index++){
                appendBranch(children[index]);
            }
        };

        for (let index = 0; index < roots.length; index++){
            appendBranch(roots[index]);
        }

        return items;
    }

    private _fetchedResultsController:MIOFetchedResultsController = null;
    set fetchedResultsController(value){
        if (value == null && this._fetchedResultsController != null)
            this._fetchedResultsController.delegate = null;

        this._fetchedResultsController = value;
    }

    get fetchedResultsController(){
        if (this._fetchedResultsController != null)
            return this._fetchedResultsController;

        let ad = MUIWebApplication.sharedInstance().delegate;
        let sortDescriptors = [ MIOSortDescriptor.sortDescriptorWithKey('orderIndex', true),
                                MIOSortDescriptor.sortDescriptorWithKey('name', true)
                            ];
        let fetchRequest = DBHelper.listFetchRequestWithEntityName("StockCategory", sortDescriptors, null);
        fetchRequest.relationshipKeyPathsForPrefetching = ['subCategories', 'superCategory'];

        let fetchedResultsController = new MIOFetchedResultsController();
        fetchedResultsController.initWithFetchRequest(fetchRequest, ad.managedObjectContext, null);
        fetchedResultsController.delegate = this;
        fetchedResultsController.performFetch();

        this._fetchedResultsController = fetchedResultsController;
        return this._fetchedResultsController;
    }

    controllerDidChangeContent(controller){
        this.reloadTreeItems();
        this.tableView.reloadData();
    }


    private addStockCategory(parent:StockCategory){

        let title = parent == null ? MIOLocalizeString("NEW_STOCK_CATEGORY", "NEW STOCK CATEGORY") : MIOLocalizeString("NEW_CHILD_STOCK_CATEGORY", "NEW CHILD STOCK CATEGORY") + ": " + parent.name;

        var avc = new MUIAlertViewController();
        avc.initWithTitle(title, MIOLocalizeString("CHOOSE_A_NAME", "CHOOSE A NAME "), MUIAlertViewStyle.Default);
        avc.addTextFieldWithConfigurationHandler(this, function(textField:MUITextField){
            textField.setPlaceholderText(MIOLocalizeString("NAME","NAME"));
        });

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString('ADD','ADD'), MUIAlertActionStyle.Default, this, function(){
            let nameTF =  avc.textFields[0];
            let name = nameTF.text.trim();

            if(name.length > 0){
                let moc = MUIWebApplication.sharedInstance().delegate.managedObjectContext;
                let ws = MIOEntityDescription.insertNewObjectForEntityForName("StockCategory", moc) as StockCategory;
                ws.identifier = MIOUUID.UUID().UUIDString;
                ws.name = name;
                ws.superCategory = parent;
                moc.save();
            }
            else {
                let error = new MUIAlertViewController();
                error.initWithTitle(MIOLocalizeString('ERROR', 'ERROR'), MIOLocalizeString("CHECK_NAME", "CHECK NAME"), MUIAlertViewStyle.Default);
                error.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString('CLOSE','CLOSE'), MUIAlertActionStyle.Cancel, this, function(){}));

                this.presentViewController(error, true);
            }
        }));
        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString('CANCEL','CANCEL'), MUIAlertActionStyle.Cancel, this, function(){}));

        this.presentViewController(avc, true);
    }

    private changeParent(category:StockCategory){
        // The category itself and its subcategories can't be the new parent: that would make a cycle
        let parents = this.categoriesTree(category);

        let avc = new MUIAlertViewController();
        avc.initWithTitle(MIOLocalizeString("CHANGE_PARENT", "CHANGE PARENT") + ": " + category.name, MIOLocalizeString("CHOOSE_A_PARENT", "CHOOSE A PARENT"), MUIAlertViewStyle.Default);

        avc.addComboBoxWithConfigurationHandler(this, function(comboBox:MUIComboBox){
            comboBox.removeAllItems();
            comboBox.addItem(MIOLocalizeString("NO_PARENT_ROOT_CATEGORY", "NO PARENT (ROOT CATEGORY)"), -1);
            let selectedIndex = -1;
            for (let index = 0; index < parents.length; index++){
                let indent = "";
                for (let level = 0; level < parents[index].indentLevel; level++) indent += "   ";
                comboBox.addItem(indent + parents[index].name, index);
                if (category.superCategory != null && category.superCategory.identifier == parents[index].identifier) selectedIndex = index;
            }
            comboBox.selectItem(selectedIndex);
        });

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString('OK','OK'), MUIAlertActionStyle.Default, this, function(){
            let parentIndex = parseInt(avc.comboBoxes[0].getSelectedItem());
            let parent = parentIndex >= 0 ? parents[parentIndex] : null;

            let currentParentID = category.superCategory != null ? category.superCategory.identifier : null;
            let newParentID = parent != null ? parent.identifier : null;
            if (currentParentID == newParentID) return;

            category.superCategory = parent;
            let moc = MUIWebApplication.sharedInstance().delegate.managedObjectContext;
            moc.save();
        }));

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString('CANCEL','CANCEL'), MUIAlertActionStyle.Cancel, this, function(){}));

        this.presentViewController(avc, true);
    }


    private deleteStockCategory(delObject:StockCategory) {

        //NOTE: must delete all ProductAttributes related to the deleted ProductAttributeType
        let predicate = MIOPredicate.predicateWithFormat("superCategory.identifier == '" + delObject.identifier + "'");
        DBHelper.queryObjectsWithCompletion("StockCategory", null, predicate, ["subCategories", "superCategory"], this, function(objects){

            if (objects.length > 0){

                //reconect the StockCategory child objects to the superCategory for the deleted object
                for (let index = 0; index < objects.length; index++){
                    if (delObject.superCategory) {
                        objects[index].superCategory = delObject.superCategory;
                    } else {
                        objects[index].superCategory = null;
                    }
                }
            }

            DBHelper.deleteObjectFromMainContext(delObject, true);

            let moc = MUIWebApplication.sharedInstance().delegate.managedObjectContext;
            moc.save();
        });

    }
}
